import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SnackbarProvider, useSnackbar } from "notistack";
import { clearNotification } from "../../../../redux/notification/notificationActions";

function MyApp() {
  const dispatch = useDispatch();
  const notification = useSelector((state) => state.notification);
  const { message, variant } = notification;
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    if (message !== "") enqueueSnackbar(message, { variant });
    setTimeout(() => {
      dispatch(clearNotification());
    }, 5000);
  }, [dispatch, message, variant, enqueueSnackbar]);

  return null;
}

function IntegrationNotistack({ notification }) {
  return (
    <SnackbarProvider
      maxSnack={3}
      preventDuplicate
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <MyApp notification={notification} />
    </SnackbarProvider>
  );
}

export default IntegrationNotistack;
